<template>
	<div class="c-block-list-rte-image">
		<h2
			v-if="title"
			class="font-medium mb-[10px] text-[20px]"
			v-html="title"
		></h2>
		<div class="c-block-list-rte-image__grid">
			<div>
				<BaseImg
					v-if="images != null"
					class=" relative <760:w-full"
					:style="`width: min(100%, ${images.width}px);`"
					:src="images.cropUrl || images.url"
					:alt="images.altText"
					:width="images.width"
					:height="images.height"
					:img-attrs="{
						class: 'object-contain',
					}"
				/>
			</div>
			<div  v-if="text" class="c-block-list-rte-image__text s-rich-text" v-html="text"></div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	title: String,
	text: String,
	images: Object,
});
</script>
<script>
export default {
	inheritAttrs: false,
};

</script>

<style lang="postcss">
.c-block-list-rte-image {
	@apply bg-white text-text <760:p-[15px] p-[25px];
}
.c-block-list-rte-image__grid {
	display: grid;
	grid-template-columns: repeat( auto-fit, minmax(250px, 1fr)  );
	gap: 30px;
}
.c-block-list-rte-image__text {
	grid-column-end: span 2;
}
</style>
